import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import Text from "@/components/ui/text";
import { Add } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";

const TRANSLATION_PREFIX = "contracts.contractView.financialRecognitionModal";

interface Props {
  onAddService: () => void;
}

const EmptyServicesBanner: React.FC<Props> = ({ onAddService }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2 rounded-lg border border-border-border1 p-4 bg-surface-elevation1">
      <Text variant="body">
        {t(`${TRANSLATION_PREFIX}.emptyServicesBanner`)}
      </Text>
      <Button variant="tertiary" onClick={onAddService}>
        <IconContainer color="cta" size="5">
          <Add />
        </IconContainer>
        {t(`${TRANSLATION_PREFIX}.addService`)}
      </Button>
    </div>
  );
};

export default EmptyServicesBanner;
